import React from "react";
import "./Hero.css";

const InfoCard = ({
  title,
  description,
  link,
  linkText,
  titleVar,
  linkVar,
}) => {
  return (
    <div className="info-card">
      <h3 style={{ color: `var(${titleVar})` }}>{title}</h3>
      <div className="info-description">
        <p>{description}</p>
      </div>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: `var(${linkVar})` }}
      >
        {linkText}
      </a>
    </div>
  );
};

const TwoColumns = () => {
  return (
    <div className="two-columns">
      <InfoCard
        title="Tu postura"
        description="Programa correctivo para mejorar tu postura y tu movimiento y/o para salir de una lesión sin riesgos de recaída."
        link="https://tally.so/r/wgOve1"
        linkText="Saber más"
        titleVar="--primary-color"
        linkVar="--orange-color"
      />
      <InfoCard
        title="Tu entrenamiento"
        description="Programa para ganar fuerza a la vez que pierdes/ganas/mantienes tu peso ideal."
        link="https://tally.so/r/mVNlgg"
        linkText="Descubrir"
        titleVar="--orange-color"
        linkVar="--primary-color"
      />
    </div>
  );
};

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-content flex" data-aos="fade-down">
        <h1>Biopoweriza tu fuerza</h1>
        <p>Conquista tu movimiento.</p>
        <a href="#objetivos" className="btn btn-primary">
          Conóceme
        </a>
        <TwoColumns />
      </div>
    </section>
  );
};

export default Hero;
